/* eslint-disable no-unused-vars */
<template>
  <div class="home-outer-container">
    <MyHeader ref="header">
      <div class="btn-con" slot="nav-left"></div>
      <div class="btn-con" slot="nav-right">
        <a href="javascript:;" @click.stop="switchSearchInput" class="header-btn"><img src="~@/assets/img/search.png"
            class="search-icon" /></a>
      </div>
    </MyHeader>
    <div class="top-function">
      <transition name="scaleHeight">
        <div class="search-box" v-if="isShowSearch">
          <div class="search-con">
            <input type="text" v-model="searchId" class="input" placeholder="请输入用户ID查询" />
            <a href="javascript:;" class="search-btn" @click.stop="fetchInfoById"><span
                class="search-btn-text">搜索</span></a>
          </div>
        </div>
      </transition>

      <!-- 搜索结果弹窗 -->
      <van-popup v-model="showSearchResult" position="top">
        <div class="searching" v-if="searching">
          <loadingIcon />
        </div>
        <div class="person-item img-box" @click.stop="toInfo(searchResult.mid)" v-else-if="searchResult.id">
          <!-- <img class="img"
            v-lazy="`/api/member/pic?id=${searchResult.coverPicList && searchResult.coverPicList[0]}&type=1&targetMemberId=${searchResult.id}`" /> -->

          <img class="img" v-lazy="`${searchResult.coverPicUrlList && searchResult.coverPicUrlList[0]}`" />
          <span class="img-num" v-if="searchResult.coverPicUrlList">{{searchResult.coverPicUrlList.length}}</span>
          <div class="info-box">
            <div class="id-con">
              <span class="name-con">{{searchResult.nickName}}<img
                  v-if="parseInt(searchResult.identityAuth) === 3 && parseInt(searchResult.academicAuth) === 3 && parseInt(searchResult.workAuth) === 3"
                  class="identify-icon" src="~@/assets/img/identify.png" /></span>
              <span class="id">ID: {{searchResult.mid}}</span>
            </div>
            <p class="info-con desc">{{searchResult.age ? `${searchResult.age}岁 ` : ''}}
              {{searchResult.high ? `${searchResult.high}cm ` : ''}}{{schoolText(searchResult)}}
              {{searchResult.job}}{{searchResult.company ?`（${searchResult.company}）`: ''}}</p>
            <p class="info-con location">
              <!-- {{searchResult.cityId ? `现居${parseInt(searchResult.cityId) === 900000 ? (searchResult.country + ' ' + searchResult.state) : areaData['city_list'][searchResult.cityId]}` : ''}} -->
              {{cityText(searchResult)}}
              {{searchResult.cityId && searchResult.nativeCityId ? ' · ' : ''}}{{nativeCityText(searchResult)}}
            </p>
          </div>
        </div>
        <div class="no-searchResult" v-else>
          <img src="~@/assets/img/no-search-result.png" alt="" class="no-result-img" />
          <p class="no-result-tips">未搜索到对应用户</p>
        </div>
      </van-popup>

      <!-- <div class="combo-con" v-if="activity && activity.title">
        <a @click="toCombo" class="combo-link common-bg">
          <span class="con-left"><img class="stamp" src="~@/assets/img/bitmap.png" />{{ activity.title }}</span>
          <img class="arrow-right" src="~@/assets/img/arrow-right.png" />
        </a>
      </div> -->
      <div class="combo-con">
        <a @click="toCombo" class="combo-link common-bg">
          <span class="con-left"><img class="stamp" src="~@/assets/img/bitmap.png" />{{activityTitle}}</span>
          <img class="arrow-right" src="~@/assets/img/arrow-right.png" />
        </a>
      </div>
    </div>

    <div class="home-container">
      <van-list v-model="isLoading" :finished="finished" :finished-text="isShowCompleteInfoBtn ? '' : '没有更多了'"
        @load="onLoad" class="person-list">

        <div v-for="(item) in list" :key="item.id">
          <div v-if="item.lastMatch===1" class="soild_line">&nbsp;更多推荐&nbsp;
          </div>
          <li class="person-item img-box" @click.stop="toInfo(item.mid)">
            <img class="img" v-lazy="`${item.coverPicUrlList && item.coverPicUrlList[0]}`" />
            <span class="img-num" v-if="item.coverPicUrlList">{{item.coverPicUrlList.length}}</span>
            <div class="info-box">
              <div class="id-con">
                <span class="name-con">{{item.nickName}}<img
                    v-if="parseInt(item.identityAuth) === 3 && parseInt(item.academicAuth) === 3 && parseInt(item.workAuth) === 3"
                    class="identify-icon" src="~@/assets/img/identify.png" /></span>
                <span class="id">ID: {{item.mid}}</span>
              </div>
              <p class="info-con desc">{{item.age ? `${item.age}岁 ` : ''}}
                {{item.high ? `${item.high}cm ` : ''}}{{schoolText(item)}}
                {{item.job}}</p>
              <p class="info-con location">
                {{cityText(item)}}
                {{item.cityId && item.nativeCityId ? ' · ' : ''}}{{nativeCityText(item)}}
              </p>
            </div>
          </li>
        </div>

      </van-list>
    </div>

    <div class="complete-info-pop" v-if="isShowCompleteInfoBtn">
      <p class="tips">真诚、严肃、平等交友<br />查看更多优质会员，请先完善个人资料</p>
      <a href="javascript:;" class="jump-btn" @click="jump">{{buttonText}}</a>
    </div>

    <!-- 加速审核弹窗 -->
    <AccelerateAduit v-model="isShowAccelerate" @confirm="isShowAccelerate = false" :isBaseData="isBaseData"
      @close="isShowAccelerate = false" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MyHeader from '@/components/common/myHeader'
import loadingIcon from '@/components/common/loadingIcon'
import AccelerateAduit from '@/components/dialog/accelerateAduit'

export default {
  name: 'Home',
  components: {
    MyHeader,
    loadingIcon,
    AccelerateAduit
  },
  data () {
    return {
      activity: undefined,
      isShowSearch: false,
      searchId: '',
      searching: false,
      showSearchResult: false,
      hadResult: true,
      searchResult: {},
      isLoading: false,
      finished: false,
      list: [],
      currentPage: 1,
      pageSize: 5,
      // 完善资料弹窗
      isShowAccelerate: false,
      isBaseData: false,
      activityTitle: ''
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      educationMap: 'educationMap',
      areaData: 'areaData',
      session: 'session'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    isShowCompleteInfoBtn () {
      if (!this.userId) return true
      // 基础资料未首次审核通过时，只允许访问前5名用户
      if (!this.userData.firstBaseAuth) {
        return true
      }
      // 身份认证未全部审核通过或者修改的基础资料未通过审核时，允许访问前20名用户
      let keys = ['baseDataAuth', 'identityAuth', 'academicAuth', 'workAuth']
      for (let index = 0; index < keys.length; index++) {
        let item = keys[index]; let option = this.userData[item]
        if ([0, 1, 2].includes(option) && this.currentPage > 4) {
          return true
        }
      }
      return false
    },
    buttonText () {
      if (!this.userId) return '请登录'
      let { basedataAuth } = this.userData

      if (basedataAuth === 0) return '请完善个人资料'
      if (basedataAuth === 1) return '等待资料审核中'
      if (basedataAuth === 2) return '资料未通过审核，请修改重新提交'

      let map = { identityAuth: '身份', academicAuth: '学历', workAuth: '工作' }

      for (let index = 0, keys = Object.keys(map); index < keys.length; index++) {
        let item = keys[index]; let label = map[item]; let option = this.userData[item]
        // 审核不通过状态提示优先级最高
        if (option === 2) return `${label}认证未通过审核，请修改重新提交`
        if (option === 1) return `${label}认证等待审核中`
        if (option === 0) return `请进行${label}认证`
      }
      return ''
    },
    isAuthUser () {
      return parseInt(this.userData.basedataAuth) === 3 &&
        parseInt(this.userData.identityAuth) === 3 &&
        parseInt(this.userData.academicAuth) === 3 &&
        parseInt(this.userData.workAuth) === 3
    },

    // 所在城市
    cityText (item) {
      return (item) => {
        if (!item.cityId) {
          return ''
        }
        if (parseInt(item.cityId) === 900000) return '现居' + (item.country + ' ' + item.state)
        return `现居${this.areaData['city_list'][item.cityId]}`
      }
    },
    nativeCityText (item) {
      return (item) => {
        if (!item.nativeCityId) {
          return ''
        }
        let nid = parseInt(item.nativeCityId)
        if (nid === 900000) {
          return item.nativeCountry + ' ' + item.nativeState + '人'
        } else {
          const provice = String(nid).substr(0,2) + '0000'
          return `${[110100, 120100, 310100, 500100].indexOf(nid) >= 0 ? '' : `${this.areaData['province_list'][provice]}`}${this.areaData['city_list'][item.nativeCityId]}人`
        }
      }
    },
    schoolText (item) {
      return (item) => `${this.educationMap[item.education]}${item.ifStudent ? '（在读）' : ''}`
    }
  },
  watch: {
    showSearchResult (val) {
      if (val) {
        this.$refs['header'].$el.style.zIndex = 3000
      } else {
        setTimeout(() => {
          this.$refs['header'].$el.style.zIndex = 99
        }, 500)
      }
    },
    userData (val, oldVal) {
      if (!val || !oldVal) return
      if (this.isAuthUser) {
        window.removeEventListener('scroll', this.scroll)
      }
      if (this.currentPage ===  1) return
      // 择偶条件更改时，重新加载列表数据
      if (
        val.selectCountry !== oldVal.selectCountry ||
        val.selectState !== oldVal.selectState ||
        val.selectionAcadmic !== oldVal.selectionAcadmic ||
        val.selectionAgeMax !== oldVal.selectionAgeMax ||
        val.selectionAgeMin !== oldVal.selectionAgeMin ||
        val.selectionCityId !== oldVal.selectionCityId ||
        val.selectionCountryId !== oldVal.selectionCountryId ||
        val.selectionHighMax !== oldVal.selectionHighMax ||
        val.selectionHighMin !== oldVal.selectionHighMin ||
        val.selectionSingleStatus !== oldVal.selectionSingleStatus ||
        val.selectCountry !== oldVal.selectCountry ||
        val.selectState !== oldVal.selectState
      ) {
        this.currentPage = 1
        this.list = []
        this.isLoading = true
        this.onLoad()
      }
    },
    session(val, oldVal){
      if (val) {
        console.log('new:', val)
        console.log('old:', oldVal)
        this.currentPage=1
        this.finished = false
        this.onLoad()
      }
    }
  },
  methods: {
    switchSearchInput () {
      this.isShowSearch = !this.isShowSearch
      if (this.isShowSearch) {
        this.$nextTick(() => {
          document.querySelector('.input').focus()
        })
      }
    },
    onLoad () {
      this.$helloHttp('/activitys/title', {}, "get").then(res => {
        console.log(res)
        this.activityTitle = res.data;
      });
      this.$http('/api/member/list', {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000') {
          const data = res.data
          if (data.currentPage === 1) {

            this.list = data.data
          } else if (data.data && data.data.length) {
            if (data.currentPage === this.currentPage) {
              //防止脏数据
              this.list = [...this.list, ...data.data]
            }else {

            }
          }

          if (data.currentPage === this.currentPage) {
            if (data.data.length === 0 || !this.userId) {
              this.finished = true
            } else {
              this.currentPage++
            }
          }
        } else if (res.code === '100001') {
          //出现系统错误时重新加载第一页
          this.currentPage = 1
          //this.$toast('网络错误,请刷新或重新进入系统')
          this.onLoad()
        }else {
          this.finished = true
          res.code !== '100005' && res.code !== '100006' && this.$toast(res.msg)
        }
      }, () => {
        this.finished = true
        this.isLoading = false
      })
    },
    fetchInfoById () {
      if (!this.userId) {
        this.$toast('使用本功能需要先登录')
        this.$router.push({
          path: '/account.html'
        })
        return
      }
      if (!/^\d{2,6}$/.test(this.searchId)) {
        this.$toast('请输入正确的用户id')
        return
      }
      this.searching = true
      this.showSearchResult = true
      this.$http('/api/member/info', {
        targetMid: this.searchId
      }, 'get').then(res => {
        this.searching = false
        if (res.code === '0000') {
          this.searchResult = res.data
        } else {
          this.searchResult = {}
          this.$toast(res.msg)
        }
      }, () => {
        this.searching = false
      })
    },
    toInfo (id) {
      this.isShowSearch = false
      this.showSearchResult = false
      setTimeout(() => {
        this.$router.push({
          path: `/info-${id}.html`
        })
      }, 1)
    },
    jump () {
      const jumpAccount = () => this.$router.push({ path: '/account.html' })
      const { basedataAuth, identityAuth, academicAuth, workAuth, status } = this.userData

      let map = { identityAuth: '身份', academicAuth: '学历', workAuth: '工作' }

      if (!this.userId) return jumpAccount()

      if (status === 0) {
        return this.$router.push({
          path: '/setUserData/sex.html'
        })
      }

      if ([0, 2].includes(basedataAuth)) {
        return this.$router.push({
          path: '/baseInfo.html'
        })
      }

      if (basedataAuth === 1) {
        return jumpAccount()
      }

      for (let index = 0, keys = Object.keys(map); index < keys.length; index++) {
        let item = keys[index]; let label = map[item]; let option = this.userData[item]
        if ([0, 2].includes(option)) return jumpAccount()
        if (option === 1) {
          this.isBaseData = true
          // eslint-disable-next-line no-return-assign
          return this.isShowAccelerate = true
        }
      }
    },
    toCombo() {
      location.href = "http://activity.hellobuluo.com"
      // if (this.activity && this.activity.url) {
      //   location.href = this.activity.url
      // }
    }
    // jump2 () {
    //   const baseAuth = parseInt(this.userData.basedataAuth)
    //   const identityAuth = parseInt(this.userData.identityAuth)
    //   const academicAuth = parseInt(this.userData.academicAuth)
    //   const workAuth = parseInt(this.userData.workAuth)
    //   // 先判断完基础资料审核状态
    //   if (!this.userId) {
    //     this.$router.push({
    //       path: '/account.html'
    //     })
    //   } else if (parseInt(this.userData.status) === 0) {
    //     this.$router.push({
    //       path: '/setUserData/sex.html'
    //     })
    //   } else if (baseAuth === 0 || baseAuth === 2) {
    //     this.$router.push({
    //       path: '/baseInfo.html'
    //     })
    //   } else if (
    //     identityAuth === 0 ||
    //     academicAuth === 0 ||
    //     workAuth === 0 ||
    //     identityAuth === 2 ||
    //     academicAuth === 2 ||
    //     workAuth === 2
    //   ) {
    //     this.$router.push({
    //       path: '/account.html'
    //     })
    //   } else if (
    //     baseAuth === 1 ||
    //     identityAuth === 1 ||
    //     academicAuth === 1 ||
    //     workAuth === 1
    //   ) {
    //     this.isShowAccelerate = true
    //   }
    // },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/constant.scss";
.bottomTips {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
}
.scaleHeight-enter-active,
.scaleHeight-leave-active {
  opacity: 1;
  height: 96px;
  transition: all linear 0.2s;
}
.scaleHeight-enter,
.scaleHeight-leave-to {
  opacity: 0;
  height: 0;
}
.home-outer-container {
  .top-function {
    position: sticky;
    top: 88px;
    z-index: 10;
    padding: 0 $space;
    background: #fff;
  }
  .search-box {
    position: relative;
    padding-top: 10px;
    padding-bottom: 30px;
    z-index: 2900;
  }
  .search-con {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    border-radius: 60px;
    overflow: hidden;
  }
  .input {
    flex: 1 1 auto;
    padding: 0 45px;
    border: 1px solid #9b9b9b;
    border-right: none;
    border-radius: 60px 0 0 60px;
    font-size: 32px;
    line-height: 56px;
  }
  .search-btn {
    // flex: 0 0 192px;
    width: 192px;
    background: linear-gradient(124deg, #ff72c3 0%, #ff3e90 100%);
  }
  .search-btn-text {
    display: block;
    color: #fff;
    font-size: 32px;
    line-height: 60px;
    text-align: center;
  }

  // 设置弹层以覆盖头部和搜索框
  .van-popup--top {
    padding: 188px 40px 14px;
  }
  // 搜索中
  .searching {
    .loader {
      margin: auto;
      width: 80px;
      height: 80px;
    }
  }
  // 无搜索结果页
  .no-searchResult {
    padding: 120px 40px 220px;
    text-align: center;
    .no-result-img {
      width: 90px;
    }
    .no-result-tips {
      margin-top: 20px;
      color: #b6b6b6;
      font-size: 32px;
      line-height: 44px;
    }
  }

  .combo-link {
    z-index: 10;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px 30px 20px 20px;
    border-radius: 4px;
    font-size: 28px;
    color: #fff;
    .stamp {
      margin-right: 20px;
      width: 34px;
      display: inline-block;
      vertical-align: middle;
    }
    .arrow-right {
      width: 13px;
      height: 22px;
    }
  }
  .person-item {
    margin-bottom: 30px;
    width: 100%;
    height: 470px;
    border-radius: 8px;
    box-shadow: 0 4px 10px #ddd;
    overflow: hidden;
  }
  .soild_line {
    position: relative;
    text-align: center;
    width: 100%;
    margin: 30px auto;
    height: 20px;
    font-size: 14px;
    color: #e5e5e5;
    line-height: 1;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 46%;
      border-bottom: 1px solid #e5e5e5;
      width: 40%;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
  .info-box {
    position: absolute;
    bottom: 0;
    padding: 7px 30px;
    width: 100%;
    background: rgba(255, 255, 255, 0.8);
  }
  .id-con {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  .name-con,
  .id {
    font-size: 28px;
    line-height: 40px;
    font-weight: bold;
  }
  .identify-icon {
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    width: 90px;
  }
  .info-con {
    margin-top: 7px;
    line-height: 34px;
  }
}
.home-container {
  padding: 0 $space;
}

.complete-info-pop {
  position: relative;
  padding: 30px 40px 56px;
  background: #fff;
  .tips {
    font-size: 27px;
    line-height: 44px;
    text-align: center;
  }
  .jump-btn {
    display: block;
    margin-top: 30px;
    padding: 25px;
    color: #fff;
    font-size: 32px;
    line-height: 50px;
    text-align: center;
    border-radius: 50px;
    background: linear-gradient(
      305deg,
      rgba(255, 62, 144, 1) 0%,
      rgba(255, 187, 216, 1) 100%
    );
  }
}
</style>
